import { synchronizeCommands as synchronize } from "../duck/epics";
import commandFiles from "src/modules/command/command-files";

const clearData = commandFiles.deleteAll;

export default {
  synchronize,
  clearData
};
